import { render, staticRenderFns } from "./AttendanceDeparture.vue?vue&type=template&id=45d3b0fe&scoped=true&"
import script from "./AttendanceDeparture.vue?vue&type=script&lang=js&"
export * from "./AttendanceDeparture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d3b0fe",
  null
  
)

export default component.exports